var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 12,
    viewBox: "0 0 8 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.83006 11.0002C7.01631 10.8128 7.12085 10.5594 7.12085 10.2952C7.12085 10.031 7.01631 9.77756 6.83006 9.59019L3.29006 6.00019L6.83006 2.46019C7.01631 2.27283 7.12085 2.01938 7.12085 1.75519C7.12085 1.49101 7.01631 1.23756 6.83006 1.05019C6.73709 0.956464 6.62649 0.88207 6.50463 0.831301C6.38277 0.780533 6.25207 0.754395 6.12006 0.754395C5.98805 0.754395 5.85734 0.780533 5.73548 0.831301C5.61362 0.88207 5.50302 0.956464 5.41006 1.05019L1.17006 5.29019C1.07633 5.38316 1.00193 5.49376 0.951166 5.61562C0.900397 5.73747 0.874259 5.86818 0.874259 6.00019C0.874259 6.1322 0.900397 6.26291 0.951166 6.38477C1.00193 6.50663 1.07633 6.61723 1.17006 6.71019L5.41006 11.0002C5.50302 11.0939 5.61362 11.1683 5.73548 11.2191C5.85734 11.2699 5.98805 11.296 6.12006 11.296C6.25207 11.296 6.38277 11.2699 6.50463 11.2191C6.62649 11.1683 6.73709 11.0939 6.83006 11.0002Z",
    fill: "#54565A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/arrow-left.e92b09fe2b538dfde4cfcd61e2937a9f.svg";
export { ForwardRef as ReactComponent };